<template>
  <div>
    <h1 class="title">
      {{ $t('message["590"]') }}
    </h1>
    <template>
      <query
        v-if="personsList.length"
        ref="query"
        :userid="userid"
        @active="activeSelect"
      />
    </template>
    <div
      v-if="menuList.length>0"
      class="notice-setting-box"
    >
      <a-tabs
        v-if="activeName"
        v-model="activeName"
        :animated="false"
        @change="handleClick"
      >
        <a-tab-pane
          v-for="item in menuList"
          :key="item.scope"
          :tab="item.name"
        >
          <table-list :active-label="activeLabel" />
        </a-tab-pane>
      </a-tabs>
    </div>
    <div
      v-if="isShow"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />
      <p class="placeholder">
        {{ noQuitTip[0] }} {{ quitName.truename }} {{ noQuitTip[1] }}
      </p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Query from '@/components/pc/quit/Query'
import TableList from './TableList'
export default {
  components: {
    Query,
    TableList
  },
  data () {
    return {
      activeName: '',
      allLables: {
        follow: this.$t('message["1580"]'),
        dev: this.$t('message["548"]'),
        input: this.$t('message["619"]'),
        audit: this.$t('message["1046"]')
      },
      activeLabel: this.$t('message["1580"]'),
      isShow: false
    }
  },
  computed: {
    ...mapState('quit', ['personsList', 'menuList', 'quitName']),
    baseinfo () {
      return this.$store.state.baseinfo
    },
    userid () {
      return Number(this.$route.query.userid) || 0
    },
    noQuitTip () {
      return this.$t('message["625"]').split('|')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setQuitListDatas({})
    })
  },
  async created () {
    const chain = await this.getPeronsDatas()
    chain.params({ pk: 'inquiry-followup' })
      .onSuccess(() => {
        document.title = this.$t('message["590"]') + ' - ' + this.baseinfo.projectname + '-' + this.baseinfo.comname
      })
      .fetch()
  },
  methods: {
    ...mapActions('quit', ['getPeronsDatas', 'getMenuList']),
    ...mapMutations('quit', ['setQuitListDatas']),
    handleClick (activeKey) {
      this.activeLabel = this.allLables[activeKey]

      // 获取列表数据
      this.$refs.query._getPeronListsDatas({
        userid: this.$route.query.userid,
        scope: this.activeName
      })
    },
    activeSelect (b, val) {
      this.isShow = b
      this.activeName = val

      if (this.menuList && this.menuList[0]) {
        this.activeLabel = this.allLables[this.menuList[0].scope]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notice-setting-box::v-deep {
  font-size: 18px;
  margin-top: 16px;
  .ant-tabs-bar {
    border-bottom: none 0;
  }
  .ant-tabs-nav .ant-tabs-tab {
    font-size: 18px;
    font-weight: bold;
  }
}
.empty-box {
  text-align: center;
  .logo {
    display: block;
    margin: 64px auto 8px;
    font-size: 24px;
    color: #d6d6d6;
  }
  .placeholder {
    margin-bottom: 16px;
    color: $gray3;
  }
}
</style>
